import React from 'react';
export function Masterclass() {
  // 1. ID del video de YouTube de tu masterclass (lo que va después de "watch?v=").
  //    Ej: en https://youtube.com/watch?v=dQw4w9WgXcQ el ID es "dQw4w9WgXcQ".
  const YOUTUBE_ID = 'Vp2yxIuhiBs';
  // 2. URL a la que redirige el botón CTA al hacer click.
  const CTA_URL = 'https://tudominio.com/acceso';
  return <section className="w-full bg-black px-5 sm:px-8 lg:px-12 py-12 lg:py-20" data-id="element-3">
      <div className="max-w-3xl mx-auto flex flex-col items-center text-center" data-id="element-4">
        {/* Título persuasivo */}
        <h1 className="text-[1.5rem] leading-[1.2] sm:text-4xl sm:leading-tight lg:text-5xl font-bold mb-8 lg:mb-10 text-balance max-w-[20ch] sm:max-w-none" data-id="element-5">
          Descubrí el{' '}
          <span className="underline decoration-brand-orange decoration-4 underline-offset-4" data-id="element-6">
            Sistema Paso a Paso
          </span>{' '}
          para Crear y Escalar un Negocio de Ebooks que Puede Generarte{' '}
          <span className="text-brand-orange text-glow" data-id="element-7">
            Ingresos en Dólares
          </span>
        </h1>

        {/* Espacio para el video de la masterclass */}
        <div className="w-full aspect-video rounded-xl overflow-hidden border-2 border-brand-orange bg-brand-dark mb-8 lg:mb-10 box-glow" data-id="element-8">
          {YOUTUBE_ID ? <iframe className="w-full h-full" src={`https://www.youtube.com/embed/${YOUTUBE_ID}?rel=0`} title="Masterclass" allow="accelerated-sensors; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen data-id="element-9" /> : <div className="w-full h-full flex flex-col items-center justify-center text-gray-500 px-6 text-center" data-id="element-10">
              <div className="w-16 h-12 bg-red-600 rounded-xl flex items-center justify-center mb-4" data-id="element-11">
                <div className="w-0 h-0 border-t-[8px] border-t-transparent border-l-[14px] border-l-white border-b-[8px] border-b-transparent ml-1" data-id="element-12" />
              </div>
              <p className="text-sm font-medium" data-id="element-13">
                Pegá el ID de tu video de YouTube en el código
              </p>
              <p className="text-xs mt-1 opacity-70" data-id="element-14">
                Variable YOUTUBE_ID en components/Masterclass.tsx
              </p>
            </div>}
        </div>

        {/* Botón CTA que redirige a otra URL */}
        <a href={CTA_URL} className="w-full sm:w-auto px-10 py-4 lg:py-5 bg-brand-orange hover:bg-red-600 text-white text-base lg:text-lg font-bold rounded-lg transition-all transform hover:scale-105 active:scale-95 box-glow pt-[16px] pb-[16px] mt-[10px]" data-id="element-15">
          ¡QUIERO ACCEDER AHORA!
        </a>
      </div>
    </section>;
}